import moment from "moment";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { ClickableCellRenderer } from "tap/components/AGGrid/cell-renderers/ClickableCellRenderer.jsx";

export const statusIndicator = {
  headerName: "",
  field: "status",
  width: 20,
  cellRenderer: ({ value }) => (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        background: "#fff",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 2,
          top: 0,
          bottom: 0,
          width: "4px",
          background: getColorForStatus(value),
          borderRadius: "2px",
        }}
      />
      <span
        style={{
          marginLeft: "4px",
          background: getColorForStatus(value),
          display: "inline-block",
          width: "100%",
          height: "100%",
        }}
      >
        &nbsp;
      </span>
    </div>
  ),
  cellStyle: { padding: 0 },
  suppressHeaderMenuButton: true,
  sortable: false,
  filter: false,
};

export const view = (onOpenViewRateCardDrawer) => ({
  field: "",
  headerName: "",
  cellRenderer: ClickableCellRenderer(onOpenViewRateCardDrawer, "fa-eye"),
  width: 20,
});

export const edit = (onOpenEditRateCardModal) => ({
  field: "",
  headerName: "",
  cellRenderer: ClickableCellRenderer(onOpenEditRateCardModal, "fa-pencil"),
  width: 20,
});

export const id = {
  field: "id",
  headerName: "ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "rateCards",
  },
  minWidth: 100,
};

export const rateCardName = {
  field: "rateCardName",
  headerName: "Name",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "rateCardName",
    page: "rateCards",
  },
  minWidth: 300,
};

export const windowSequenceName = {
  field: "windowSequence.windowSequenceName",
  headerName: "Window Sequence",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "windowSequenceName",
    page: "rateCards",
  },
  minWidth: 300,
};

export const currency = {
  field: "currency",
  headerName: "Currency",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "currency",
    page: "rateCards",
  },
  minWidth: 300,
};

export const priceType = {
  field: "priceType",
  headerName: "Price Type",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "priceType",
    page: "rateCards",
  },
  minWidth: 150,
};

export const revShareType = {
  field: "revShareType",
  headerName: "Rev Share",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "revShareType",
    page: "rateCards",
  },
  minWidth: 150,
};

export const isTpr = {
  field: "isTpr",
  headerName: "TPR",
  cellRenderer: ({ value }) => {
    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return value ? "Yes" : "No";
  },
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "isTpr",
    page: "rateCards",
  },
  minWidth: 150,
};

export const status = {
  field: "status",
  headerName: "Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "status",
    page: "rateCards",
  },
  minWidth: 150,
  cellRenderer: ({ value }) => {
    let iconType, color;
    if (value === "ACTIVE") {
      iconType = "fa-regular fa-circle-check";
      color = "#4caf50";
    } else if (value === "INACTIVE") {
      iconType = "fa-regular fa-circle-xmark";
      color = "red";
    } else if (value === "NEEDS_ATTENTION") {
      iconType = "fa-solid fa-triangle-exclamation";
      color = "orange";
    } else {
      return "";
    }
    return <i className={iconType} style={{ color }}></i>;
  },
};

export const createdBy = {
  field: "createdBy.fullName",
  headerName: "Created By",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdBy",
    page: "rateCards",
  },
  minWidth: 150,
};

export const createdAt = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("DD-MMM-YYYY") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "rateCards",
  },
  minWidth: 150,
};

export const updatedBy = {
  field: "modifiedBy.fullName",
  headerName: "Updated By",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "updatedBy",
    page: "rateCards",
  },
  minWidth: 150,
};

export const modifiedAt = {
  field: "modifiedAt",
  headerName: "Modified",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("DD-MMM-YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "modifiedAt",
    page: "rateCards",
  },
  minWidth: 250,
};

function getColorForStatus(status) {
  const colors = {
    ACTIVE: "#4caf50",
    NEEDS_ATTENTION: "#ffa500",
    INACTIVE: "#f44336",
  };
  return colors[(status || "").toUpperCase()] || "#ccc";
}
